import { render, staticRenderFns } from "./SmMaterialInputArea.vue?vue&type=template&id=43ee41fc&scoped=true&"
import script from "./SmMaterialInputArea.vue?vue&type=script&lang=ts&"
export * from "./SmMaterialInputArea.vue?vue&type=script&lang=ts&"
import style0 from "./SmMaterialInputArea.vue?vue&type=style&index=0&id=43ee41fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ee41fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
